/**
 * Override FacetWP's default behavior
 */
export function facetoverrides() {
	const skeleton   = document.querySelector( '.facet-skeleton' )
	const checkboxes = document.querySelector( '.facetwp-type-checkboxes' )

	if ( ! skeleton || ! checkboxes) {
		console.warn( 'Required DOM elements not found for facet overrides.' )
		return
	}

	document.addEventListener(
		'facetwp-refresh',
		function () {
			generateSkeletonLines()
			skeleton.classList.remove( 'hidden' )
			checkboxes.classList.add( 'hidden' )
		}
	)

	document.addEventListener(
		'facetwp-loaded',
		function () {
			skeleton.classList.add( 'hidden' )
			checkboxes.classList.remove( 'hidden' )
		}
	)

	// Wait for FacetWP to finish loading
	document.addEventListener(
		'facetwp-loaded',
		function () {
			// Find the input - replace the selector to suit your specific setup
			const input = document.querySelector( '.facetwp-search' );

			if (input && ! input.parentNode.querySelector( '.clear-svg' )) {
				// Create the SVG element
				const svgNS = "http://www.w3.org/2000/svg";
				const svg   = document.createElementNS( svgNS, 'svg' );
				svg.setAttributeNS( null, 'width', '24' );
				svg.setAttributeNS( null, 'height', '24' );
				svg.setAttributeNS( null, 'viewBox', '0 0 24 24' );
				svg.classList.add( 'clear-svg' );

				const path = document.createElementNS( svgNS, 'path' );
				path.setAttributeNS( null, 'd', 'M18 6 6 18M6 6l12 12' );
				path.setAttributeNS( null, 'stroke', '#00283C' );
				path.setAttributeNS( null, 'stroke-width', '2' );
				path.setAttributeNS( null, 'stroke-linecap', 'round' );
				path.setAttributeNS( null, 'stroke-linejoin', 'round' );

				svg.appendChild( path );
				svg.style.display = 'none';

				// Add SVG after the input
				input.parentNode.insertBefore( svg, input.nextSibling );

				// Event listener for showing/hiding clear SVG
				input.addEventListener(
					'input',
					() => {
                    if (input.value.length > 0) {
                        svg.style.display = 'block';
                        input.classList.add( 'has-value' );
                    } else {
							svg.style.display = 'none';
							input.classList.remove( 'has-value' );
						}
					}
				);

				// Event listener for the clear SVG
				svg.addEventListener(
					'click',
					() => {
                    input.value       = '';
                    svg.style.display = 'none';
                    // If needed, refresh the FacetWP
						FWP.autoload();
					}
				);
			}
		}
	);

	document.addEventListener(
		'facetwp-loaded',
		function () {
			// Replace this selector with the specific one that targets your reset button
			const resetButton = document.querySelector( '.facetwp-reset' );

			if (resetButton) {
				resetButton.classList.add( 'tertiary' );
			}
		}
	);

}

/**
 * Generate skeleton lines for facets as a preloader
 */
export function generateSkeletonLines() {
	const container = document.querySelector( '.facet-skeleton' )
	if ( ! container) {
		return
	}

	const tag_amount = parseInt( container.dataset.tagAmount, 10 )
		if (isNaN( tag_amount )) {
			console.warn( 'Invalid tag amount for facet skeleton.' )
			return
	}
	container.innerHTML = ''  // Clear previous skeleton lines

	for (let i = 0; i < tag_amount; i++) {
		const line        = document.createElement( 'div' )
		const randomWidth = Math.floor( Math.random() * (150 - 50 + 1) + 50 )

		line.className   = 'skeleton-line'
		line.style.width = `${randomWidth}px`

		container.appendChild( line )
	}
}
